<template>
  <div class="main not-select" :id="option.id">
    <div class="flex-between-center">
      <div class="flex">
        <div :style="{minWidth: avatarSize}" @click="toMineNav(option.createUserId)">
<!--          <el-avatar :src="option.pic" :size="avatarSize" style="border: 1px solid #eee"></el-avatar>-->
          <el-avatar v-if="option.pic && option.pic !== '/images/mine_deep.png'" :size="avatarSize" :src="option.pic" style="border: 1px solid #eee;margin:0 6px"></el-avatar>
          <el-avatar v-else :size="avatarSize" src="./../../../static/user_pic_default.png" style="border: 1px solid #eee;margin:0 6px"></el-avatar>
        </div>
        <div style="margin-left: 10px">
          <div style="font-size: 13px;color: #999;padding-bottom: 3px" @click="toMineNav(option.createUserId)">
            <span>{{option.userName}}</span>
            <span class="author" v-if="option.createUserId === option.wuserId">作者</span>
          </div>
          <div style="font-size: 14px;color: #050505">
            <span v-if="option.replyCommentId">
              <span>回复</span>
              <span style="color: #999">{{option.replyUserName}}</span>：
            </span>
            <span class="comment-text not-select">
              <span v-if="option.content" :id="`com-${option.id}`">{{option.content}}</span>
              <span v-else style="color: #d8d8d8">该评论已删除</span>
            </span>
            <span style="font-size: 10px;color: #999">{{option.createTime | reactTime}}</span>
          </div>
        </div>
      </div>
      <div class="flex-column" style="padding:0 12px" v-if="option.content">
        <img :src="option.like ? agreeAct : agree" style="width:18px" @click="like">
        <div style="font-size: 12px;letter-spacing: 0px;text-align: center">{{option.likeNum | reactNumber}}</div>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios'
    import { getCookie } from '../../util/util'

    export default {
      name: 'comment',
      props: {
        option: {
          type: Object,
          default: {}
        }
      },
      data () {
        return {
          agree: require('../../assets/heart.png'),
          agreeAct: require('../../assets/heart-act.png')
        }
      },
      computed: {
        avatarSize () {
          return this.option.parentId === 0 ? 36 : 26
        }
      },
      mounted() {
        this.$nextTick(() => {
          // 绑定点击、长按事件
          let timer = 0
          let dom = document.getElementById(`com-${this.option.id}`)

          if (dom) {
            dom.onclick = () => {
              this.$emit('TouchCom', this.option)
            }
            // 长按事件
            dom.ontouchstart = (e) => {
              timer = setTimeout(() => {
                e.preventDefault()
                this.$emit('LongPress', this.option)
              }, 600);
            }
            dom.ontouchmove = () => {
              clearTimeout(timer)
              timer = 0
            }
            dom.ontouchend = () => {
              clearTimeout(timer)
              if (timer === 0) {
                return false
              }
            }
          }
        })
      },
      methods: {
        like () {
          if (getCookie("jianyanwang_token")) {
            let {id} = this.option
            axios.post(`/video/work/comment/like/${id}`).then(({data}) => {
              if (data.code === 0) {
                let {like, likeNum} = data
                this.$set(this.option, 'like', like)
                this.$set(this.option, 'likeNum', likeNum)
                this.Toast({message: like === 0 ? '取消点赞' : '点赞成功'})
              }
            })
          } else {
            this.$emit('login')
          }
        },
        toMineNav(createUserId) {
          this.$router.push({
            path: this.$store.state.user.userId === createUserId ? '/mineNav' : '/mineNavOther',
            query: {
              createUserId: createUserId
            }
          })
        }
      }
    }
</script>

<style scoped>
  .main {
    margin: 7px 0;
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
  }
  .author {
    background: #f4f4f4;padding:1px 7px;
    border-radius: 8px;font-size:12px
  }
</style>



// WEBPACK FOOTER //
// src/pages/video/comment.vue